import TitleWrap from '../../molecules/TitleWrap';
import BoxWrap from '../../molecules/BoxWrap';
import Grid from '../../atoms/Grid';
import { IMemberProps } from '../../../../common/interface/props';

import ResetPassword2 from '../../../form/reset-password-form';

function ResetPasswordForm({ solType }: IMemberProps) {
  return (
    <Grid display="flex" justifyContent="center">
      <Grid width={500}>
        <TitleWrap />
        <BoxWrap>
          <BoxWrap.Bottom>
            <ResetPassword2 solType={solType} />
          </BoxWrap.Bottom>
        </BoxWrap>
      </Grid>
    </Grid>
  );
}

export default ResetPasswordForm;
